import { render, staticRenderFns } from "./ReferenceFilterScreeningStatus.vue?vue&type=template&id=0baffc7e&"
import script from "./ReferenceFilterScreeningStatus.vue?vue&type=script&lang=js&"
export * from "./ReferenceFilterScreeningStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports